import { createClient } from "@supabase/supabase-js";

export const supabase = createClient(
  "https://zrzwgmmwbeavzkhsbsmu.supabase.co",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InpyendnbW13YmVhdnpraHNic211Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzA4MTU5NDEsImV4cCI6MjA4NjM5MTk0MX0.Lr9OIcN-URgWJfjQXlN0zJUCENtfd3lMJX4R4BxSf3Q"
);